import React, { useMemo } from 'react';

// DEPENDENCIES
import findKey from 'lodash/findKey';

// GLOBAL VARIABLES
import { INVENTORY_STATUS } from 'codes.js';

// HOOKS
import { useRecordContext } from 'helpers/getRecordData';

// MAIN COMPONENT
export const checkInventoryStatus = (Component, statusList = [], operand = true) => props => {

  // HOOKS
  const { record: { inventory_status_code } = {} } = useRecordContext() || {};

  // MEMOS
  const hasStatus = useMemo(
    () => statusList.includes(findKey(INVENTORY_STATUS, ['code', inventory_status_code])),
    [inventory_status_code]
  )

  // RENDER
  return hasStatus === operand && <Component {...props} />;
};
